import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import HeaderTable from '@/components/platform/copySpeach/HeaderTable.vue';
import TitleCell from '@/components/platform/copySpeach/TitleCell.vue';
import { CopySpeachStatus } from '@/store/enums/speachEnum';
import Cell from '@/components/platform/copySpeach/Cell.vue';
import UserCell from '@/components/platform/copySpeach/UserCell.vue';
var SpeachConfigureTable = /*#__PURE__*/function (_Vue) {
  function SpeachConfigureTable() {
    var _this;
    _classCallCheck(this, SpeachConfigureTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpeachConfigureTable, [].concat(args));
    _defineProperty(_this, "listSpeach", void 0);
    return _this;
  }
  _inherits(SpeachConfigureTable, _Vue);
  return _createClass(SpeachConfigureTable, [{
    key: "getIconFromStatus",
    value: function getIconFromStatus(status) {
      switch (status) {
        case CopySpeachStatus.SUCCESS:
          {
            return "check-circle-outline";
          }
        case CopySpeachStatus.ERROR:
          {
            return "alert-circle-outline";
          }
        default:
          {
            return "clock-outline";
          }
      }
    }
  }, {
    key: "getTypeFromStatus",
    value: function getTypeFromStatus(status) {
      switch (status) {
        case CopySpeachStatus.SUCCESS:
          {
            return "is-success";
          }
        case CopySpeachStatus.ERROR:
          {
            return "is-danger";
          }
        default:
          {
            return "is-black";
          }
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  default: []
})], SpeachConfigureTable.prototype, "listSpeach", void 0);
SpeachConfigureTable = __decorate([Options({
  components: {
    HeaderTable: HeaderTable,
    TitleCell: TitleCell,
    Cell: Cell,
    UserCell: UserCell
  }
})], SpeachConfigureTable);
export default SpeachConfigureTable;